import { RAISE_API_V1_URL } from "constants/endpoints";
import { put, post } from "services/api";

const securityRequestURL = `${RAISE_API_V1_URL}/security_verifications/device_verification`;

/**
 * @param {Object} params
 * @param {'sms'|'voice'} params.method used to select current method to device verification
 *
 * @returns {Promise<Object>}
 * @returns {Object} data
 * @returns {string|undefined} data.code - sent only to Raise users
 */
export const selectDeviceToVerificate = async ({ method }) => {
  const response = await post(securityRequestURL, {
    device_verification: {
      delivery_method: method
    }
  });
  return response.data.data;
};

/**
 * @param {Object} params
 * @param {'sms'|'voice'} params.method used to select current method to device verification
 * @param {String} params.code code sent to verificate user's device
 *
 * @returns {Promise<Object>}
 * @returns {Object} data
 * @returns {String} data.access_token - new user token
 * @returns {Date} data.token_expiration
 */
export const validateVerificationCode = async ({ code, method }) => {
  const response = await put(securityRequestURL, {
    device_verification: {
      code,
      delivery_method: method
    }
  });
  return response.data.data;
};
